const SEQUENTIAL = "0f6ecdb7-4696-11e9-82f6-0242ac120002";
const UPFRONT = "1637af02-4696-11e9-82f6-0242ac120002";

export const mezzFundingStructureList = [
  { name: "Sequential", value: SEQUENTIAL },
  { name: "Upfront", value: UPFRONT }
];

export default {
  SEQUENTIAL,
  UPFRONT
};
